function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import VectorLayer from 'ol/layer/Vector';
import { useCallback } from 'react';
import { useOpenLayers } from '../react-ol';
import { findLayersOfType } from '../utils/findLayers';
import { validateGeometry } from '../utils/validateGeometry';

class ValidateFeaturesResult {
  constructor() {
    _defineProperty(this, "_results", new Array());
  }

  include(result) {
    this._results.push(result);
  }

  get isValid() {
    return !this._results.some(result => !result.isValid);
  }

  get allFeatures() {
    return this._results;
  }

  get validFeatures() {
    return this._results.filter(result => result.isValid);
  }

  get invalidFeatures() {
    return this._results.filter(result => !result.isValid);
  }

}

class ValidateFeatureError {
  constructor(errorType, errorMessage) {
    this.errorType = errorType;
    this.errorMessage = errorMessage;
    this.errorType = errorType;
    this.errorMessage = errorMessage;
  }

}

class ValidateFeatureResult {
  constructor(layer, feature) {
    this.layer = layer;
    this.feature = feature;

    _defineProperty(this, "_errors", new Array(0));

    this.layer = layer;
    this.feature = feature;
  }

  withError(errorType, errorMessage) {
    this._errors.push(new ValidateFeatureError(errorType, errorMessage));
  }

  get isValid() {
    return this._errors.length === 0;
  }

  get errors() {
    return this._errors;
  }

  get errorType() {
    var _this$_errors$;

    return (_this$_errors$ = this._errors[0]) === null || _this$_errors$ === void 0 ? void 0 : _this$_errors$.errorType;
  }

  get errorMessage() {
    var _this$_errors$2;

    return (_this$_errors$2 = this._errors[0]) === null || _this$_errors$2 === void 0 ? void 0 : _this$_errors$2.errorMessage;
  }

  get hasMultipleErrors() {
    return this._errors.length > 1;
  }

}

var useValidateFeatures = () => {
  var {
    map
  } = useOpenLayers();
  return useCallback(id => {
    var results = new ValidateFeaturesResult();

    if (map) {
      var ids = Array.isArray(id) ? id : [id];
      var layers = findLayersOfType(map, VectorLayer, vectorLayer => ids.some(id => id === vectorLayer.get('id')));

      for (var _layer of layers) {
        var _layer$getSource;

        var features = (_layer$getSource = _layer.getSource()) === null || _layer$getSource === void 0 ? void 0 : _layer$getSource.getFeatures();

        if (features) {
          for (var _feature of features) {
            var geometry = _feature.getGeometry();

            if (geometry) {
              (function () {
                var featureResult = new ValidateFeatureResult(_layer, _feature);
                var geometryResult = validateGeometry(geometry);

                if (!geometryResult.isValid) {
                  geometryResult.errors.forEach(geometryError => featureResult.withError(geometryError.errorType, geometryError.errorMessage));
                }

                results.include(featureResult);
              })();
            }
          }
        }
      }
    }

    return results;
  }, [map]);
};

export { useValidateFeatures, ValidateFeaturesResult, ValidateFeatureResult, ValidateFeatureError };